import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/site';
import { SectionCta } from './SectionCta';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-cream px-5 py-14 sm:px-6 sm:py-20" data-id="element-101" data-mp="1bm3h3kiqi6zw">
      <div className="mx-auto max-w-2xl" data-id="element-102" data-mp="1gitycb69z8mw">
        <h2 className="text-center font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-103" data-mp="1glpubtykbn8p">
          Frequently asked questions
        </h2>

        <ul className="mt-8 space-y-2.5" data-id="element-104" data-mp="289q832x1gx5y">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.q} className="overflow-hidden rounded-xl border border-navy/10 bg-white" data-id="element-105" data-mp="1uhae0rm489h6" data-mpi={i}>
                <h3 data-id="element-106" data-mp="1zgd5f996ah6o">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-sand/60" data-id="element-107" data-mp="2n822f2wxvtty">
                    <span className="text-[15px] font-bold leading-snug text-navy" data-id="element-108" data-mp="10v04agp7dyle">{faq.q}</span>
                    <ChevronDownIcon className={`mt-0.5 h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-109" data-mp="1em55hn87yyxu" />
                  </button>
                </h3>
                {isOpen ? <p className="border-t border-navy/10 px-4 py-4 text-[14.5px] leading-relaxed text-navy/70" data-id="element-110" data-mp="1xjpm670tyr7d">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <SectionCta headline="No subscription, no waiting — access lands in your inbox." label="Get instant access now" data-id="element-111" data-mp="36q3u652fiwe" />
      </div>
    </section>;
}